import { useCallback } from "react";

import { MyLensesLensStatus } from "../../gql-generated/types";
import { SubmissionError, SubmissionErrors } from "../../lens/models";

import { useLensStatus } from "./useLensStatus";

export const useLensStatusCheck = (lensId: string): { checkLensStatus: () => Promise<void> } => {
    const { getUpdatingLensStatus } = useLensStatus(lensId);

    const checkLensStatus = useCallback(async () => {
        if (lensId) {
            const response = await getUpdatingLensStatus();
            if (response.data?.getLens.lens?.status === MyLensesLensStatus.LensStatusInReview) {
                throw new SubmissionError(SubmissionErrors.LensIsInReview);
            }
        }
    }, [lensId, getUpdatingLensStatus]);

    return { checkLensStatus };
};
